import React, { useEffect } from 'react';
import { format, startOfMonth } from 'date-fns';
import { Controller } from 'react-hook-form';
import { Col, Row, FormGroup } from 'reactstrap';
import Datepicker from 'components/Inputs/DatePicker';
import { useUsers } from 'views/Report/Protocol/hooks/useUsers';
import FlexSelect from 'components/Inputs/FlexSelect';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import { POSSIBLE_FILTERS_ENTITIES } from 'hooks/useMemorizeInputsFilters';
import { useMemorizeFilters } from 'hooks/useMemorizeInputsFilters';

const dateRules = {
  required: 'Data é obrigatória',
  pattern: {
    value: /^[0-3][0-9]\/[0-1][0-9]\/[0-9][0-9][0-9][0-9]$/,
    message: 'Data inválida! (dd/MM/aaaa)'
  }
};
const getDateBegin = () => {
  const date = new Date();
  const firstDayMonth = new Date(
    date.getFullYear('pt-br'),
    date.getMonth('pt-br'),
    1
  );
  return format(startOfMonth(firstDayMonth), 'dd/LL/yyyy');
};
const toISOFormat = (dateTimeString) => {
  const [date] = dateTimeString.split(' ');
  const [DD, MM, YYYY] = date.split('/');
  return `${DD}/${MM}/${YYYY}`;
};

const DefaultFieldsFilterForm = ({
  control,
  setValue,
  getValues,
  showNoResponsible,
  setShowNoResponsible
}) => {
  const { userList } = useUsers();
  const { getMemorizedFilters, changeUniqueMemorizedFilter } =
    useMemorizeFilters(POSSIBLE_FILTERS_ENTITIES.CRM_ACCOUNT_DASHBOARD);

  useEffect(() => {
    const filters = getMemorizedFilters();
    if (filters && typeof filters.showNoResponsible !== 'undefined') {
      setShowNoResponsible(filters.showNoResponsible);
    }
  }, []);

  return (
    <>
      <Row className="mb-3">
        <Col sm="4">
          <label className="form-control-label">Data inicial</label>
          <Controller
            render={(props) => (
              <Datepicker
                fieldName="dateBegin"
                valueController={setValue}
                defaultValue={props.value}
              />
            )}
            control={control}
            name="dateBegin"
            rules={dateRules}
            defaultValue={getDateBegin()}
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Data final</label>
          <Controller
            render={(props) => (
              <Datepicker
                fieldName="dateEnd"
                valueController={setValue}
                defaultValue={props.value}
              />
            )}
            control={control}
            name="dateEnd"
            defaultValue={new Date().toLocaleDateString('pt-br')}
            rules={{
              ...dateRules,
              validate: async (value) => {
                if (
                  new Date(toISOFormat(value)) <
                  new Date(toISOFormat(getValues()['dateBegin']))
                ) {
                  return 'A data final não pode ser anterior à inicial!';
                } else {
                  return true;
                }
              }
            }}
          />
        </Col>
        <Col sm="4">
          <label className="form-control-label">Responsável</label>
          <Controller
            render={(props) => (
              <FlexSelect
                dataOptions={userList || []}
                isMulti={true}
                value={props.value}
                valueController={setValue}
                fieldName="responsibleLogin"
                labelName="name"
                valueName="login"
                isClearable={true}
                closeMenuOnSelect={false}
              />
            )}
            control={control}
            name="responsibleLogin"
            defaultValue=""
          />
          <FormGroup className="mt-2">
            <label
              className="form-control-label"
              style={{ marginLeft: '-15px' }}
            >
              <ToggleSwitch
                id="showNoResponsible"
                checked={!!showNoResponsible}
                onChange={() => {
                  setShowNoResponsible(!showNoResponsible);
                  changeUniqueMemorizedFilter(
                    'showNoResponsible',
                    !showNoResponsible
                  );
                }}
                default={false}
              />
              Mostrar contas sem responsável
            </label>
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};

export default DefaultFieldsFilterForm;
